



























import { defineComponent, PropType } from '@nuxtjs/composition-api'
import useHelper from '@/utils/helper'
import { StoryblokComponent } from '~/types/storyblok-vue'

export interface CancelAppointmentModal extends StoryblokComponent<'CancelAppointmentModal'> {
  content: StoryblokComponent<any>[]
  custom_classes: string
  title: string
  description: string
}

export default defineComponent({
  props: {
    blok: {
      type: Object as PropType<CancelAppointmentModal>,
      default: () => {}
    }
  },
  setup(props, { emit }) {
    const { concatClasses, dashify } = useHelper()
    const classes = concatClasses(props.blok)

    const cancel = () => {
      emit('cancelAppointment')
    }
    const close = () => {
      emit('close')
    }

    return {
      cancel,
      classes,
      dashify,
      close
    }
  }
})
